var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pipeline)?_c('div',[_vm._l((_vm.pipeline),function(notification,index){return [_c('bell-notification',{key:`${notification.validatorName}-${notification.payloadId}-${index}`,attrs:{"data":notification}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }